import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { environment } from '../../../environments/environment';
import { IRegistrationData } from '../interfaces/IRegistrationData';
import { IRegistrationDataRequest } from '../interfaces/IRegistrationDataRequest';
import { IHotLeadRequest } from '../interfaces/IHotLeadRequest';

import { INav } from '../../buyer/interfaces/INav';
import { INavCampaign } from '../interfaces/INavCampaign';
import { IBuyerErrorModal } from '../../buyer/interfaces/model';
import { StaticService } from '../../static/static.service';

@Injectable({
  providedIn: 'root'
})
export class GuestService {
  private readonly baseUrl = environment.adminBaseUrl;
  restapiverb = 'register';
  userRole = '';
  restAPI = '';
  isRegistered = false;
  isLoggedIn = false;
  // private _isLogginPopupOpen = false;
  leadId = null;

  errorModal: IBuyerErrorModal = {
    bodyText: '',
    title: 'Server Error',
    isShown: false
  };

  constructor(private http: HttpClient, private router: Router,
    private authService: AuthService,
    public staticService: StaticService
  ) {
  }

  // Called when user clicks the register button after filling out the registration form.
  registerUser(userData: IRegistrationDataRequest): Observable<any> {
    this.restAPI = 'guests';
    const url = environment.adminUrl + this.restAPI;
    return this.http.post<any>(url, userData);
  }

  registerHotLeadUser(userData: IHotLeadRequest): Observable<string> {
    this.restAPI = 'guests';
    const url = environment.adminUrl + this.restAPI;
    return this.http.put<string>(url, userData);
  }

  getGuestEmail(email?: string): Observable<{}> {
    const url = `${this.baseUrl}api/guests`;
    return this.http.get(url, { params: this.emailParams(email) });
  }

  getAllTypesEmail(email?: string): Observable<{}> {
    const url = `${this.baseUrl}api/guests/emailExist`; 
    return this.http.get(url, { params: this.emailParams(email) });
  }

  getGuestEmailByEmail(email: string): Observable<{}> {
    const url = `${this.baseUrl}api/guests`;
    return this.http.get(url, { params: this.emailParams(email) });
  }

  getGuestAuthRealm(email: string): Observable<{}> {
    const url = `${this.baseUrl}api/guests/connection`;
    return this.http.get(url, { params: this.emailParams(email) });
  }

  private emailParams(email?: string): HttpParams | undefined {
    const trimmed = email?.trim();
    return trimmed ? new HttpParams().set('email', trimmed) : undefined;
  }

}

